import { useState } from "react";
import "../styles/Editable.css";

function StatefulView({ states }) {
  const [selectedState, setSelectedState] = useState(0);
  return states[selectedState](setSelectedState);
}

export default StatefulView;
